import axios from '@src/utils/axios'

const module = 'finance'
const axiosInstance = axios(false);

export default {
  'pagination': (ctx, data) => axiosInstance.get(`/${module}/paginate`, {params:data}),
  'find': async (ctx, data) => {
    return await axiosInstance.get(`/${module}/` + data.id)
  },
  'myEarning': () => axiosInstance.get(`/${module}/my_earning`)
}